import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOldAllMember,
  UpdateOldAllMember,
} from "../../Redux/Slice/AddMember";
import DynamicTable from "../../Components/Table/DynamicTable";
import Loader from "../../Components/Loader/Loader";
import defaultProfile from "../../Image/Daynamic_Logo_Piture.png";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import jsPDF from "jspdf";

/* ================= BASE64 HELPER ================= */
const convertToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const emptyDoc = { Photo: "", Date: "" };
const emptyCheque = { Photo: "", Name: "", Number: "" };

const formatDate = (value) => {
  if (!value) return "";

  // Agar object hai aur Date field hai
  if (typeof value === "object") {
    if (value.Date) {
      return value.Date.includes("T") ? value.Date.split("T")[0] : value.Date;
    }
    return "";
  }

  // Agar string hai
  if (typeof value === "string") {
    return value.includes("T") ? value.split("T")[0] : value;
  }

  return "";
};

/* ================= BOND END DATE CALC ================= */
const calculateBondEndDate = (startDate, months) => {
  if (!startDate || !months) return "";
  const date = new Date(startDate);
  date.setMonth(date.getMonth() + Number(months));
  return date.toISOString().split("T")[0];
};

const EmpOldDetails = () => {
  const dispatch = useDispatch();
  const { MemberOldAllData } = useSelector((state) => state.AddMemberSlice);

  /* ================= BASIC FORM ================= */
  const [formValues, setFormValues] = useState({
    JoiningDate: "",
    BondSignDate: "",
    BondStartDate: "",
    BondEndDate: "",
    BondTime: "",
    internshiptime: "",
    Firm: "",
  });

  const [editing, setEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  /* ================= SALARY (MULTIPLE) ================= */
  const [salaryList, setSalaryList] = useState([
    { Salary: "", Discription: "", Date: "" },
  ]);

  const exactSalary = useMemo(() => {
    let baseSalary = 0;
    let increment = 0;

    salaryList.forEach((item) => {
      if (!item || !item.Salary) return;

      const amount = Number(item.Salary);
      if (isNaN(amount)) return;

      if (item.Discription === "Salary") {
        baseSalary = amount; // last valid salary only
      }

      if (item.Discription === "Increment") {
        increment += amount;
      }
    });

    return baseSalary + increment;
  }, [salaryList]);

  /* ================= DOCUMENT STATES (SINGLE) ================= */

  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [cheque, setCheque] = useState(emptyCheque);
  const [internshipLatter, setInternshipLatter] = useState(emptyDoc);
  const [internshipCompleteLatter, setInternshipCompleteLatter] =
    useState(emptyDoc);
  const [jobOfferLatter, setJobOfferLatter] = useState(emptyDoc);
  const [expirLatter, setExpirLatter] = useState(emptyDoc);

  /* ================= BOND PHOTOS (ONLY VIEW) ================= */
  const [bondPhotos, setBondPhotos] = useState([]);

  /* ================= ZOOM MODAL ================= */
  const [zoomImage, setZoomImage] = useState(null);

  /* ================= FETCH ================= */
  useEffect(() => {
    dispatch(fetchOldAllMember());
  }, [dispatch]);

  /* ================= AUTO CALCULATE BOND END DATE ================= */
  useEffect(() => {
    if (formValues.BondStartDate && formValues.BondTime) {
      const endDate = calculateBondEndDate(
        formValues.BondStartDate,
        formValues.BondTime
      );

      setFormValues((prev) => ({
        ...prev,
        BondEndDate: endDate,
      }));
    }
  }, [formValues.BondStartDate, formValues.BondTime]);

  const handleBondPhotosUpload = async (files) => {
    const arr = Array.from(files);

    const converted = await Promise.all(
      arr.map(async (file) => ({
        Photo: await convertToBase64(file),
        FileName: file.name,
      }))
    );

    setBondPhotos((prev) => [...prev, ...converted]);
  };

  const generateBondPDFBase64 = async () => {
    if (!bondPhotos.length) return "";

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < bondPhotos.length; i++) {
      if (i !== 0) pdf.addPage();

      pdf.addImage(bondPhotos[i].Photo, "JPEG", 10, 10, 190, 260);
    }

    // 👉 PDF → BASE64 (IMPORTANT)
    return pdf.output("datauristring");
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const bondPdfBase64 = await generateBondPDFBase64();

    const payload = {
      ...formValues,
      Salary: salaryList.map((s) => ({
        ...s,
        Date: s.Date ? new Date(s.Date).toISOString() : null,
      })),
      Cheque: cheque,
      internshipLatter: internshipLatter,
      internshipCompleteLatter: internshipCompleteLatter,
      JobOfferLatter: jobOfferLatter,
      ExpirLatter: expirLatter,
      Bond: bondPdfBase64,
    };

    if (editing) {
      await dispatch(UpdateOldAllMember({ id: editingId, data: payload }));
    } else {
      await dispatch(UpdateOldAllMember({ id: editingId, data: payload }));
    }

    dispatch(fetchOldAllMember());
    resetForm();
  };

  /* ================= RESET ================= */
  const resetForm = () => {
    setFormValues({
      JoiningDate: "",
      BondSignDate: "",
      BondStartDate: "",
      BondEndDate: "",
      BondTime: "",
      internshiptime: "",
      Firm: "",
    });
    setSalaryList([{ Salary: "", Discription: "", Date: "" }]);
    setCheque(emptyCheque);
    setInternshipLatter(emptyDoc);
    setInternshipCompleteLatter(emptyDoc);
    setJobOfferLatter(emptyDoc);
    setExpirLatter(emptyDoc);
    setBondPhotos([]);
    setEmployeeInfo(null);
    setEditing(false);
    setEditingId(null);
  };

  /* ================= EDIT FUNCTION ================= */
  const handleEdit = (id) => {
    const emp = MemberOldAllData.data.find((el) => el._id === id);
    if (!emp) return;

    setFormValues({
      JoiningDate: formatDate(emp.JoiningDate) || "",
      BondSignDate: formatDate(emp.BondSignDate) || "",
      BondStartDate: formatDate(emp.BondStartDate) || "",
      BondEndDate: formatDate(emp.BondEndDate) || "",
      BondTime: emp.BondTime || "",
      internshiptime: emp.internshiptime || "",
      Firm: emp.Firm || "",
    });

    setSalaryList(
      Array.isArray(emp.Salary) && emp.Salary.length
        ? emp.Salary.map((s) => ({
            Salary: s.Salary || "",
            Discription: s.Discription || "",
            Date: s.Date
              ? s.Date.split("T")[0]
              : s.GDate
              ? s.GDate.split("T")[0]
              : "",
          }))
        : [{ Salary: "", Discription: "", Date: "" }]
    );

    setCheque({
      Photo: emp?.Cheque?.Photo || "",
      Name: emp?.Cheque?.Name || "",
      Number: emp?.Cheque?.Number || "",
    });

    setInternshipLatter({
      Photo: emp?.internshipLatter?.Photo || "",
      Date: formatDate(emp?.internshipLatter?.Date),
      FileName: emp?.internshipLatter?.FileName || "",
    });

    setInternshipCompleteLatter({
      Photo: emp?.internshipCompleteLatter?.Photo || "",
      Date: formatDate(emp?.internshipCompleteLatter?.Date),
      FileName: emp?.internshipCompleteLatter?.FileName || "",
    });

    setJobOfferLatter({
      Photo: emp?.JobOfferLatter?.Photo || "",
      Date: formatDate(emp?.JobOfferLatter?.Date),
      FileName: emp?.JobOfferLatter?.FileName || "",
    });

    setExpirLatter({
      Photo: emp?.ExpirLatter?.Photo || "",
      Date: formatDate(emp?.ExpirLatter?.Date),
      FileName: emp?.ExpirLatter?.FileName || "",
    });

    setBondPhotos(emp?.BondPhotos || []);
    setEmployeeInfo(emp);

    setEditing(true);
    setEditingId(id);
  };

  /* ================= SINGLE DOCUMENT UI ================= */
  const SingleDocument = ({ title, data, setData }) => (
    <div className="border p-4 rounded bg-white mt-4">
      <h4 className="font-bold mb-3">{title}</h4>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 items-center">
        {/* FILE INPUT */}
        <input
          type="file"
          accept="image/*"
          className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const base64 = await convertToBase64(file);

            // Update data array with Photo (base64) and FileName
            setData({
              ...data,
              Photo: base64,
              FileName: file.name,
            });
          }}
        />

        {/* DATE INPUT */}
        <input
          type="date"
          className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
          value={data.Date || ""}
          onChange={(e) => setData({ ...data, Date: e.target.value })}
        />

        {/* IMAGE PREVIEW (URL OR BASE64 BOTH) */}
        {data.Photo && (
          <div className="flex flex-col items-center">
            <img
              src={data.Photo}
              alt="preview"
              className="h-20 w-24 object-cover border rounded mb-1"
              onClick={() => setZoomImage(data.Photo)}
            />
            {data.FileName && <span className="text-sm">{data.FileName}</span>}
          </div>
        )}
      </div>
    </div>
  );

  /* ================= TABLE ================= */
  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "MemberName", headerName: "Name", flex: 1 },
    { field: "MobileNumber", headerName: "Mobile", flex: 1 },
    { field: "Role", headerName: "Role", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={() => handleEdit(params.row.MainId)}
          className="py-2 px-3 text-white rounded-md bg-[#122A47] text-sm"
        >
          Edit
        </button>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => (
        <button
          // onClick={() => dispatch(toggleMemberStatus(params.row.MainId))}
          className="btn px-3 py-2 rounded-md text-sm"
          style={{
            backgroundColor: params.row.Profile === "On" ? "blue" : "red",
            color: "white",
          }}
        >
          {params.row.Profile}
        </button>
      ),
    },
  ];

  const rows =
    MemberOldAllData?.data?.map((el, index) => ({
      id: index + 1,
      MainId: el._id,
      MemberName: el.Name,
      MobileNumber: el.MobileNumber,
      Role: el.Role,
      Profile: el.Profile,
    })) || [];

  if (!MemberOldAllData) return <Loader />;

  /* ================= UI ================= */
  return (
    <>
      <h2 className="text-lg md:text-xl font-bold bg-[#122A47] text-white px-4 py-2 mb-4 inline-block rounded">
        Employee Details
      </h2>
      <div className="p-3">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 mx-auto rounded-full overflow-hidden border-2 border-[#122A47] shadow-md mb-4 transition-transform duration-300 hover:scale-105">
            <img
              src={
                employeeInfo?.ProfilePhoto
                  ? employeeInfo.ProfilePhoto
                  : defaultProfile
              }
              alt={employeeInfo?.Name || "Profile"}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Employee Name */}
          <h1 className="text-center text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-1">
            {employeeInfo?.Name || "Employee Name"}
          </h1>

          {/* SALARY */}
          <div className="border p-3 sm:p-4 rounded bg-white">
            <h3 className="font-bold text-sm sm:text-base">Salary History</h3>

            {salaryList.map((item = {}, index) => (
              <div
                key={index}
                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 mt-3"
              >
                <input
                  type="number"
                  min="0"
                  inputMode="numeric"
                  placeholder="Salary"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={item.Salary}
                  onChange={(e) => {
                    const value = e.target.value;

                    setSalaryList((prev) =>
                      prev.map((row, i) =>
                        i === index
                          ? { ...row, Salary: value.replace(/\D/g, "") }
                          : row
                      )
                    );
                  }}
                />

                <select
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={item?.Discription || ""}
                  onChange={(e) => {
                    setSalaryList((prev) =>
                      prev.map((row, i) =>
                        i === index
                          ? { ...row, Discription: e.target.value }
                          : row
                      )
                    );
                  }}
                >
                  <option value="">Select Type</option>
                  {["Stipend", "Salary", "Increment"].map((type) => (
                    <option
                      key={type}
                      value={type}
                      disabled={
                        type !== "Increment" && // Salary & Stipend lock
                        salaryList.some(
                          (s, i2) => s.Discription === type && i2 !== index
                        )
                      }
                    >
                      {type}
                    </option>
                  ))}
                </select>

                <input
                  type="date"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={item?.Date || ""}
                  onChange={(e) => {
                    setSalaryList((prev) =>
                      prev.map((row, i) =>
                        i === index ? { ...row, Date: e.target.value } : row
                      )
                    );
                  }}
                />

                <button
                  type="button"
                  className="bg-red-600 text-white rounded text-sm py-2"
                  onClick={() =>
                    setSalaryList((prev) => prev.filter((_, i) => i !== index))
                  }
                >
                  Remove
                </button>
              </div>
            ))}

            <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              {/* EXACT SALARY DISPLAY */}
              <div className="bg-green-100 text-green-800 px-4 py-2 rounded font-semibold text-base">
                Exact Salary : ₹ {exactSalary}
              </div>

              {/* ADD SALARY BUTTON */}
              <button
                type="button"
                className="bg-blue-600 text-white px-4 py-2 rounded text-base w-full sm:w-auto"
                onClick={() =>
                  setSalaryList([
                    ...salaryList,
                    { Salary: "", Discription: "", Date: "" },
                  ])
                }
              >
                + Add Salary
              </button>
            </div>
          </div>

          {/* BOND & FIRM DETAILS */}
          <div className="border p-4 rounded bg-white mt-4">
            <h4 className="font-bold mb-3">Bond & Firm Details</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <div>
                <label className="block mb-1 font-semibold">Joining Date</label>
                <input
                  type="date"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.JoiningDate}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      JoiningDate: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold">
                  Bond Sign Date
                </label>
                <input
                  type="date"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.BondSignDate}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      BondSignDate: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold">
                  Bond Start Date
                </label>
                <input
                  type="date"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.BondStartDate}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      BondStartDate: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="font-semibold">Bond Period (Months)</label>
                <input
                  type="number"
                  placeholder="1, 8, 12, 24, 48"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.BondTime}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      BondTime: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold">
                  Bond End Date
                </label>
                <input
                  type="date"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.BondEndDate}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold">
                  Internship Period
                </label>
                <input
                  type="number"
                  placeholder="Internship Duration"
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.internshiptime}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      internshiptime: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold">Firm</label>
                <select
                  className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                  value={formValues.Firm}
                  onChange={(e) =>
                    setFormValues({ ...formValues, Firm: e.target.value })
                  }
                >
                  <option value="">Select Firm</option>
                  <option value="Dynamic Software">Dynamic Software</option>
                  <option value="Dynamic Softlink">Dynamic Softlink</option>
                </select>
              </div>
            </div>
          </div>

          {/* CHEQUE */}
          <div className="border p-4 rounded bg-white">
            <h4 className="font-bold mb-3">Cheque Details</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <input
                type="file"
                className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const base64 = await convertToBase64(file);
                  setCheque({ ...cheque, Photo: base64 });
                }}
              />

              <select
                className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                value={cheque?.Name || ""}
                onChange={(e) => setCheque({ ...cheque, Name: e.target.value })}
              >
                <option value="">Select Bank</option>
                {[
                  "State Bank of India",
                  "HDFC Bank",
                  "ICICI Bank",
                  "Axis Bank",
                  "Kotak Mahindra Bank",
                  "Punjab National Bank",
                  "Bank of Baroda",
                  "Bank of India",
                  "Canara Bank",
                  "Indian Bank",
                  "Yes Bank",
                  "IndusInd Bank",
                  "Canara Bank",
                  "IDBI Bank",
                  "IDFC FIRST Bank",
                  "DCB Bank",
                  "RBL Bank",
                  "Federal Bank",
                  "City Union Bank",
                  "Union Bank of India",
                  "Central Bank of India",
                  "The Varachha Co-Op Bank Ltd.",
                  "Sarvodaya Commercial Co-Operative Bank",
                ]
                  .sort((a, b) => a.localeCompare(b))
                  .map((bank) => (
                    <option key={bank} value={bank}>
                      {bank}
                    </option>
                  ))}
              </select>

              <input
                type="number"
                placeholder="Number"
                className="bg-[#F3F8FB] border-2 border-black p-2 rounded w-full text-base"
                value={cheque?.Number || ""}
                onChange={(e) =>
                  setCheque({ ...cheque, Number: e.target.value })
                }
              />

              {cheque.Photo && (
                <img
                  src={cheque.Photo}
                  alt="Cheque"
                  className="h-20 mt-2 border rounded"
                  onClick={() => setZoomImage(cheque.Photo)}
                />
              )}
            </div>
          </div>

          {/* DOCUMENTS */}
          <SingleDocument
            title="Internship Letter"
            data={internshipLatter}
            setData={setInternshipLatter}
          />
          <SingleDocument
            title="Internship Completion Letter"
            data={internshipCompleteLatter}
            setData={setInternshipCompleteLatter}
          />
          <SingleDocument
            title="Job Offer Letter"
            data={jobOfferLatter}
            setData={setJobOfferLatter}
          />
          <SingleDocument
            title="Experience Letter"
            data={expirLatter}
            setData={setExpirLatter}
          />

          <div className="border p-3 rounded bg-white mt-4">
            <h4 className="font-bold mb-3">Bond Photos</h4>

            <input
              type="file"
              multiple
              accept="image/*"
              className="bg-[#F3F8FB] border-2 border-black p-2 rounded mb-3"
              onChange={(e) => handleBondPhotosUpload(e.target.files)}
            />

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {bondPhotos.map((img, index) => (
                <div key={index} className="relative">
                  <img
                    src={img.Photo}
                    className="h-24 w-full object-cover border rounded cursor-pointer"
                    onClick={() => setZoomImage(img.Photo)}
                  />

                  <button
                    type="button"
                    className="absolute top-1 right-1 bg-red-600 text-white px-2 rounded"
                    onClick={() =>
                      setBondPhotos((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button className="bg-[#122A47] w-full sm:w-auto text-white font-semibold px-3 py-2 rounded">
              {editing ? "UPDATE EMPLOYEE" : "SAVE EMPLOYEE"}
            </button>

            <button
              type="button"
              onClick={resetForm}
              className="bg-gray-500 w-full sm:w-auto text-white font-semibold px-4 py-2 rounded"
            >
              CANCEL
            </button>
          </div>
        </form>

        <div className="mt-8 overflow-x-auto">
          <DynamicTable
            rows={rows}
            columns={columns}
            searchValue={searchTerm}
            onSearchChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* ZOOM MODAL */}
        {zoomImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
            onClick={() => setZoomImage(null)}
          >
            <div
              className="relative max-h-[100vh] overflow-hidden p-4 rounded-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setZoomImage(null)}
                className="absolute top-0 right-0 text-white text-3xl"
              >
                &times;
              </button>
              <TransformWrapper
                initialScale={1}
                minScale={1}
                maxScale={5}
                wheel={{ step: 0.2 }}
                doubleClick={{ disabled: false }}
                pinch={{ disabled: false }}
                panning={{ velocityDisabled: true }}
              >
                <TransformComponent>
                  <img
                    src={zoomImage}
                    alt="Zoomed"
                    className="max-h-[80vh] mx-auto rounded-md"
                  />
                </TransformComponent>
              </TransformWrapper>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EmpOldDetails;
